<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,

  props: {
    graphData: {
      type: Object,
      default: () => { },
      required: false,
    },
  },

  data() {
    return {
      options: {
        legend: {
          position: 'bottom',
        },

        scales: {
          xAxes: [{
            gridLines: {
              display: true
            },
            stacked: true,
          }],
          yAxes: [{
            stacked: true,
            ticks: {
              min: 0,
              max: 100,
              callback: value => `${value}%`,
            },
            scaleLabel: {
              display: true,
              labelString: 'Percentage',
            },
          }],
        },

        tooltips: {
          enabled: false,
        },

        plugins: {
          datalabels: {
            formatter(value) {
              return Number(value) === 0 ? null : Number(value).toFixed(2) + '%'
            },

            backgroundColor: 'rgba(0, 0, 0, .5)',
            borderRadius: 4,
            color: '#fff',
          }
        }
      },
    }
  },

  computed: {
    graphDatasets() {
      let datasetMatrix = this.graphData.datasets.map(dataset => dataset.data)

      let datasetAmount = []
      let datasetsPercentages = []

      datasetMatrix.forEach((dataset) => {
        dataset.forEach((data, dataIndex) => {
          datasetAmount[dataIndex] === undefined
            ? datasetAmount[dataIndex] = data
            : datasetAmount[dataIndex] += data
        })
      })

      datasetsPercentages = datasetMatrix.map(dataset => {
        return dataset.map((data, i) => ((data / datasetAmount[i]) * 100).toFixed(2))
      })

      return {
        labels: this.graphData.labels,
        datasets: this.graphData.datasets.map((dataset, i) => {
          return {
            label: dataset.label,
            data: datasetsPercentages[i],
            backgroundColor: dataset.backgroundColor,
          }
        })
      }
    }
  },

  mounted() {
    this.renderChart(this.graphDatasets, this.options)
  },
}
</script>
